// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 20,
  argument: "Rules with regard to correction, discretion, and avoiding lies.",
  verses: [
    { n: 1, text: "How much better is it to reprove, than to be angry, and not to hinder him that confesseth in prayer?" },
    { n: 2, text: "The lust of an eunuch shall deflower a young maiden:" },
    { n: 3, text: "So is he that by violence executeth unjust judgment." },
    { n: 4, text: "How good is it, when thou art reproved, to shew repentance! for so thou shalt escape wilful sin." },
    { n: 5, text: "There is one that holdeth his peace, that is found wise: and there is another that is hateful, that is bold in speech." },
    { n: 6, text: "There is one that holdeth his peace, because he knoweth not what to say: and there is another that holdeth his peace, knowing the proper time." },
    { n: 7, text: "A wise man will hold his peace till he see opportunity: but a babbler, and a fool, will regard no time." },
    { n: 8, text: "He that useth many words shall hurt his own soul: and he that taketh authority to himself unjustly, shall be hated." },
    { n: 9, text: "There is success in evil things to a man without discipline, and there is a finding that turneth to loss." },
    { n: 10, text: "There is a gift that is not profitable: and there is a gift, the recompense of which is double." },
    { n: 11, text: "There is an abasement because of glory: and there is one that shall lift up his head from a low estate." },
    { n: 12, text: "There is that buyeth much for a small price, and restoreth the same sevenfold." },
    { n: 13, text: "A man wise in words shall make himself beloved: but the graces of fools shall be poured out." },
    { n: 14, text: "The gift of the fool shall do thee no good: for his eyes are sevenfold." },
    { n: 15, text: "He will give a few things, and upbraid much: and the opening of his mouth is the kindling of a fire." },
    { n: 16, text: "To day a man lendeth, and to-morrow he asketh it again: such a man as this is hateful." },
    { n: 17, text: "A fool shall have no friend, and there shall be no thanks for his good deeds." },
    { n: 18, text: "For they that eat his bread, are of a false tongue. How often, and how many will laugh him to scorn?" },
    { n: 19, text: "For he doth not distribute with right understanding that which was to be had: in like manner also that which was not to be had." },
    { n: 20, text: "The slipping of a false tongue is as one that falleth on the pavement: so the fall of the wicked shall come speedily." },
    { n: 21, text: "A man without grace is as a vain fable, it shall be continually in the mouth of the unwise." },
    { n: 22, text: "A parable coming out of a fool's mouth shall be rejected: for he doth not speak it in due season." },
    { n: 23, text: "There is that is hindered from sinning through want, and in his rest he shall be pricked." },
    { n: 24, text: "There is that will destroy his own soul through shamefacedness, and by occasion of an unwise person he will destroy it: and by respect of person he will destroy himself." },
    { n: 25, text: "There is that for bashfulness promiseth to his friend, and maketh him his enemy for nothing." },
    { n: 26, text: "A lie is a foul blot in a man, and yet it will be continually in the mouth of men without discipline." },
    { n: 27, text: "A thief is better than a man that is always lying: but both of them shall inherit destruction." },
    { n: 28, text: "The manners of lying men are without honour: and their confusion is with them without ceasing." },
    { n: 29, text: "A wise man shall advance himself with his words, and a prudent man shall please the great ones." },
    { n: 30, text: "He that tilleth his land shall make a high heap of corn: and he that worketh justice shall be exalted: and he that pleaseth great men shall escape iniquity." },
    { n: 31, text: "Presents and gifts blind the eyes of judges, and make them dumb in the mouth, so that they cannot correct." },
    { n: 32, text: "Wisdom that is hid, and treasure that is not seen: what profit is there in them both?" },
    { n: 33, text: "Better is he that hideth his folly, than the man that hideth his wisdom." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Prayer. A friend's excuses must be heard. (Calmet) — Greek, \"and he who apologises shall be preserved from ruin.\" Grabe adds, \"how good is it for one who has been rebuked,\" &c.,", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "(Haydock) — Thus the guilty merit pardon, and the innocent obtain a greater reward, and satisfy for former offences.", attribution: "Worthington" }
    ] },
    { verse: 2, notes: [
      { text: "Maiden. Or \"woman,\" (Haydock) who has been entrusted to his care. (Menochius) — Such people are not free from concupiscence, which must be restrained by the virtue of chastity.", attribution: "St. Augustine, contra Jul. vi. 14." }
    ] },
    { verse: 8, notes: [
      { text: "Hated. As the pests of society. See Cicero, off. 1.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Loss. The prosperity of the wicked must not be envied, Psalm xxxviii. 1, 8.", attribution: "Calmet" }
    ] },
    { verse: 11, notes: [
      { text: "Glory. Galba \"would have been universally deemed worthy of the empire, if he had not reigned.\" (Tacitus, Hist. 1.) — Adrian VI thought the pontificate the greatest misfortune to which he had been exposed; and this observation was engraven on his tomb. — Estate. By merit.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Sevenfold. As the merchandise was good for nothing, which the miser had obtained for a little money, thinking to save thereby.", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: "Graces. Or favours bestowed with ill-nature.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Sevenfold. He expects more. (Calmet) — His intention is full of guile, who flattereth and detracteth for the sake of gain.", attribution: "Worthington" }
    ] },
    { verse: 15, notes: [
      { text: "Much. As Dido did. \"This is to make a display of favours to excite hatred.\"", attribution: "Sen.[Seneca?] Ben." }
    ] },
    { verse: 16, notes: [
      { text: "Hateful. He seems to distrust you, and will not permit his goods to be of any service.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "Have. Greek, \"say I have,\" &c. — His. Greek, \"my,\" as also [in]", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "(Haydock) — Such is the language of the fool.", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "That, &c. Riches and poverty are both wrong to misers and fools. Greek, \"he had as well be without any thing.\"", attribution: "Calmet" }
    ] },
    { verse: 20, notes: [
      { text: "Pavement. It is equally destructive.", attribution: "Haydock" }
    ] },
    { verse: 21, notes: [
      { text: "Grace, (acharis) impolite and importunate.", attribution: "Calmet" }
    ] },
    { verse: 23, notes: [
      { text: "Shall. Greek adds, \"not.\" Yet if a person has had the will to offend, he must repent, though he could not put it in execution.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "Himself. Being afraid to beg for necessaries, or given too much.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Nothing. People are always displeased, when a promise is broken.", attribution: "Calmet" }
    ] },
    { verse: 26, notes: [
      { text: "Man. \"It is the vice of slaves.\"", attribution: "Aristotle, Ethic." }
    ] },
    { verse: 27, notes: [
      { text: "Lying. He exposes honour and virtue, without making restitution. (Calmet) — He throws all into confusion, and we can trust him with nothing.", attribution: "Menochius" }
    ] },
    { verse: 29, notes: [
      { text: "A. Greek adds a title, \"discourses of proverbs.\"", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "And....exalted, is not in Greek but explains the meaning of the former sentence. — Escape. Greek, \"obtain pardon for iniquity.\" (Haydock) — The great will protect him.", attribution: "Haydock" }
    ] },
    { verse: 31, notes: [
      { text: "Make. Greek, \"like a bit in the mouth, remove corrections,\" Exodus xxiii. 8.", attribution: "Calmet" }
    ] },
    { verse: 32, notes: [
      { text: "Both? He who, through a false humility refuses to take charge of others, resembles a man who locks up his corn in time of scarcity. (St. Gregory, Part. iii. 26.) (Matthew xxv.) (Calmet) — Wisdom must be shewn for the benefit of others.", attribution: "Worthington" }
    ] },
    { verse: 33, notes: [
      { text: "Folly. He may still appear to have some sense, and injures none. — It is convenient to conceal faults, provided they be amended.", attribution: "Worthington" }
    ] },
  ],
};

export default chapter;
